import Vue from 'vue'
import iView from 'iview'
import { router } from './router/index'
import store from './store'
import App from './app.vue'
import 'iview/dist/styles/iview.css'
import VueLocalStorage from 'vue-ls'
import { sync } from 'vuex-router-sync'

Vue.use(VueLocalStorage, {
  namespace: 'piano_'
});
sync(store, router)
Vue.use(iView)

new Vue({
  el: '#app',
  router: router,
  store: store,
  render: h => h(App),
  mounted() {
    //this.$store.commit('updateMenulist')
    this.$store.dispatch('updateMenulist')
  }
});


// WEBPACK FOOTER //
// ./src/main.js